module.exports = __webpack_public_path__ + "img/HU10949638.d4951548.png";